
























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ProjectService } from "@/services/project-service";
import { SalesProject } from "@/models/project";
import UserBasic from "@/components/UserBasic.vue";
import { subject as an } from "@casl/ability";

@Component({
  name: "SalesProjectsList",
  components: {
    UserBasic,
  },
})
export default class SalesProjectsList extends Vue {

  @Prop()
  private isBusy!: boolean;

  @Prop()
  private isError!: boolean;

  totalRows = 1;
  currentPage = 1;
  perPage = 20;
  pageOptions = [10, 20, 50];
  sortBy = "updated_on";
  sortDesc = true;
  sortDirection = "asc";
  filter = null;

  salesProjectsList: Array<SalesProject> = new Array<SalesProject>();

  project_service: ProjectService = new ProjectService();

  created() {
    this.getSalesProjects();
  }

  // mounted() {
  // }

  getSalesProjects() {
    this.isBusy = true;
    this.isError = false;
    this.salesProjectsList = new Array<SalesProject>();
    this.project_service
      .getSalesProjects()
      .then((response) => {
        if (response.data) {
          response.data.forEach((project: SalesProject) => {
            // if (this.$ability.can("read", an("SalesProject", project))) {
              // FIXME as usual, we need to clarify why we need 'an'
              this.salesProjectsList.push(project);
            // }
          });
        }
        this.isBusy = false;
        this.isError = false;
      })
      .catch((error) => {
        console.log(error);
        this.isBusy = false;
        this.isError = true;
      });
  }

  get sProjects() {
    if (this.salesProjectsList) {
      this.totalRows = this.salesProjectsList.length;
      return this.salesProjectsList.map((project: SalesProject) => {
        const tmpProject = project;
        if (!tmpProject.is_open) {
          tmpProject._rowVariant = "secondary";
        }
        tmpProject._cellVariants = {};
        if (tmpProject.effort_time_cap == null && tmpProject.spent_hours > 0) {
          tmpProject._cellVariants.effort_time_cap = "danger";
        }
        // tmpProject.done_ratio === 100
        //   ? (tmpProject._cellVariants.done_ratio = "success")
        //   : "";
        // tmpProject.estimated_hours > tmpProject.effort_cap
        //   ? (tmpProject._cellVariants.estimated_hours = "danger")
        //   : "";
        // tmpProject.spent_hours > tmpProject.estimated_hours
        //   ? (tmpProject._cellVariants.spent_hours = "danger")
        //   : "";
        // tmpProject.expected_hours > tmpProject.hours_left
        //   ? (tmpProject._cellVariants.expected_hours = "danger")
        //   : "";
        // tmpProject.eff_03 >= 200
        //   ? (tmpProject._cellVariants.eff_03 = "dark")
        //   : tmpProject.eff_03 >= 150
        //   ? (tmpProject._cellVariants.eff_03 = "danger")
        //   : tmpProject.eff_03 >= 100
        //   ? (tmpProject._cellVariants.eff_03 = "warning-orange")
        //   : tmpProject.eff_03 >= 80
        //   ? (tmpProject._cellVariants.eff_03 = "warning")
        //   : (tmpProject._cellVariants.eff_03 = "success");
        // tmpProject.eff_04 >= 200
        //   ? (tmpProject._cellVariants.eff_04 = "dark")
        //   : tmpProject.eff_04 >= 150
        //   ? (tmpProject._cellVariants.eff_04 = "danger")
        //   : tmpProject.eff_04 >= 100
        //   ? (tmpProject._cellVariants.eff_04 = "warning-orange")
        //   : tmpProject.eff_04 >= 80
        //   ? (tmpProject._cellVariants.eff_04 = "warning")
        //   : (tmpProject._cellVariants.eff_04 = "success");
        return tmpProject;
      });
    }

    return this.salesProjectsList;
  }

  goToProjectIssues(
    projectId: string,
    projectName: string,
    projectDescription: string,
    estimated_hours: number,
    progress: number,
    spent_hours: number,
    eff_03: number,
    eff_04: number,
    eff_05: number
  ) {
    // let eff03Style = "",
    //   eff04Style = "";
    // eff_03 >= 200
    //   ? (eff03Style = "background-color: #7E7E7E; color: white;")
    //   : eff_03 >= 150
    //   ? (eff03Style = "background-color: #B82507; color: white;")
    //   : eff_03 >= 100
    //   ? (eff03Style = "color: #EAA00B")
    //   : eff_03 >= 80
    //   ? (eff03Style = "color: #EBEB00")
    //   : (eff03Style = "color: #5DAB1B");
    // eff_04 >= 200
    //   ? (eff04Style = "background-color: #7E7E7E; color: white;")
    //   : eff_04 >= 150
    //   ? (eff04Style = "background-color: #B82507; color: white;")
    //   : eff_04 >= 100
    //   ? (eff04Style = "color: #EAA00B")
    //   : eff_04 >= 80
    //   ? (eff04Style = "color: #EBEB00")
    //   : (eff04Style = "color: #5DAB1B");
    // this.$router.push({
    //   name: "projectIssues",
    //   params: { id: projectId },
    //   query: {
    //     name: projectName,
    //     description: projectDescription,
    //     estimatedHours: estimated_hours.toString(),
    //     progress: progress.toString(),
    //     spentHours: spent_hours.toString(),
    //     eff03: eff_03.toString(),
    //     eff04: eff_04.toString(),
    //     eff05: eff_05.toString(),
    //     eff03Style: eff03Style,
    //     eff04Style: eff04Style,
    //   },
    // });
  }

  goToProjectRoadmap(projectId: string, projectName: string) {
    // this.$router.push({
    //   name: "versions",
    //   params: { id: projectId },
    //   query: { name: projectName },
    // });
  }

  get fields() {
    // Sales Projects
    return [
      { key: "actions", label: "Actions" },
      { key: "name", label: "Name", tdClass: "td-bold", sortable: true },
      { key: "project_type", label: "Type", sortable: true },
      { key: "description", label: "Description" },
      // { key: "vips", label: "VIPs" },
      {
        key: "spent_time_distribution",
        label: "Spent time distribution by issue state (hours)",
        headerAbbr: "STD",
        sortable: true,
      },
      {
        key: "spent_hours",
        label: "Spent time (hours)",
        headerAbbr: "ST",
        sortable: true,
      },
      {
        key: "effort_time_cap",
        label: "Effort cap (hours)",
        headerAbbr: "Cap",
        tdClass: "td-bold",
        sortable: true,
      },
      {
        key: "estimated_hours",
        label: "Estimated time (hours)",
        headerAbbr: "ET",
        sortable: true,
      },
      { key: "customer", label: "Customer", sortable: true },
      { key: "business_unit", label: "Business Unit", sortable: true },
      { key: "updated_on", label: "Updated on", sortable: true },
    ];
  }

}
